/* eslint-disable */
// 口袋自动登录
import axios from 'axios';

/** 通用方法 */
/**
 * 核对版本号
 * @param {string} wantVersion 想要的版本  x.x.x
 * @param {string} appVersion  当前APP的版本  x.x.x
 * @return {Boolean} true ：不用升级 false：需要升级
 */
 var compareVersion = function (wantVersion, appVersion) {

    let wantArr = wantVersion.split(".").slice(0, 3);
    let appArr = appVersion.split(".").slice(0, 3);
    let i = 0;
    let len = Math.max(wantArr.length, appArr.length);
    let wantStr = '';
    let appStr = '';
  
    function strFormat(num) {
      return String('000' + num).slice(-3);
    }
  
    for (; i < len; i++) {
      wantStr += strFormat(wantArr[i]);
      appStr += strFormat(appArr[i]);
    }
  
    return wantStr <= appStr;
  };
  
  // 设备判断
  const ua = navigator.userAgent.toLowerCase();
  const is = {
    // android =  KDM3GNEW/1.0
    // ios = 15E148KDM3GNEW201909
    android: function () {
      return /(android)/i.test(ua) && /(kdm3gnew\/1\.0)/i.test(ua)
    },
    ios: function () {
      return /(iphone|ipad|ipod|ios)/i.test(ua) && /(kdm3gnew201909)/i.test(ua)
    }
  };
  
  // 口袋全局ID
  const kdId = 'kdwebjs';

  let antiKd = window.location.search.indexOf('authorization') > -1 ? 1 : 0;	
  
  /** start */
  var kd = {
    isApp: function () {
      return typeof kdjs !== 'undefined' || typeof callKDMSGToResponse !== 'undefined'
    },
  
    // 匹配版本号
    isVersion({
      ios = '',
      android = ''
    }) {
      return (is.android() && compareVersion(android, kdjs.getKDVersion())) || (is.ios() && compareVersion(ios, getKDVersion()));
    },
  
    // 是否已登录口袋
    hasLogged: function () {
      if (is.android()) {
        return kdjs.getKDUid()
      } else if (is.ios()) {
        return typeof getKDUid !== 'undefined'
      }
    },
  
    // 获取口袋登录信息
    getUserInfo: function () {
      
      if (is.android()) {
        return {
          uid: kdjs.getKDUid(), // 数字id
          token: kdjs.getKDToken(kdId),
          areaId: kdjs.getKDAreaId(), // 口袋绑定的大区 wegame = 17||18
          secheme: kdjs.getKDTokenSecheme(),  
          aid: kdjs.getKDAid() || '', // 邮箱 || 手机号
          fromType : kdjs.fromType() || '',  //   0=电魂账号  808/809= weagme账号（账号组给了logintype传logintype，没给就传0）
          loginType : kdjs.fromType() || ''
        }
      } else if (is.ios()) {
        return {
          uid: getKDUid(),
          token: getKDToken(kdId),
          areaId: getKDAreaId(),
          secheme: getKDTokenSecheme(),
          aid: getKDAid() || '',
          fromType : fromType() || '',
          loginType : fromType()  || ''
        }
      }
    },
  
    // 打开统军令验证弹窗
    openTjlDialog({
      pid = "", // 活动期号
      uid = "", // 玩家ID
      token = "", // 支持各种token的形式
      order = "", // 订单号
      mb = "" // 支付梦币
    }) {
  
      if (!this.isApp()) {
        alert('不在口袋中');
      }
      if (!this.hasLogged()) {
        alert('口袋未登录');
      }
      if (!pid || !order || !uid || !mb || !token) {
        alert('参数不足');
      }
  
      if (is.android()) {
        kdjs.openTjlDialog(JSON.stringify({
          pid,
          uid,
          token,
          order,
          mb
        }))
      } else {
        // alert(`ios openTjlDialog`)
        window.webkit.messageHandlers.openTjlDialog.postMessage({
          pid,
          uid,
          token,
          order,
          mb
        })
        // openTjlDialog(JSON.stringify())
      }
  
    },
  
    // 打开口袋登录弹窗
    showLoginPage: function () {
      if (is.android()) {
        if (typeof kdjs.openLoginPage !== 'undefined') {
          kdjs.openLoginPage()
        } else {
          debug('\u7248\u672c\u8fc7\u4f4e\uff0c\u4e0d\u652f\u6301\u8be5\u529f\u80fd\uff01')
        }
      } else if (is.ios()) {
        if (typeof getKDVersion !== 'undefined') {
          var n = parseInt(getKDVersion().replace(/\D/g, ''))
  
          if (n > 310) {
            callKDMSGToResponse(encodeURI(JSON.stringify({
              'responseType': 12
            })))
          } else {
            debug('\u7248\u672c\u8fc7\u4f4e\uff0c\u4e0d\u652f\u6301\u8be5\u529f\u80fd\uff01')
          }
        }
      }
    },
  
    /**
     * 口袋免登陆调用
     * @return false = 未在口袋APP中||未登录口袋 true = 可发起免登陆请求
     */
    freeLoginData: function () {
      
      if (this.isApp() && this.hasLogged()) {
        var user = this.getUserInfo();
        // alert(user)
        // alert(JSON.stringify(user))
        return {
          id: kdId,
          uid: user.uid,
          area_id: user.areaId,
          token: user.token,
          secheme: user.secheme,
          aid: user.aid,
          fromType : user.fromType
        }
      }
      return false
    },

    freeLogin: function (free_url,callback) {
		if (this.isApp() && this.hasLogged()&&!antiKd) {
		  var user = this.getUserInfo();
		  user.id = kdId;

		//kdget(free_url, user, callback);
          axios.get(free_url,{
              params : user
          })
          .then(res => {
            callback(res.data);
          });

		} else {
		  if (typeof callback === 'function') {
			callback()
		  }
		}
	},    
  
  };
  
export default kd;
  


// WEBPACK FOOTER //
// ./src/assets/js/kd.js